import { useMemo } from 'react';

import { normalizeTripsSchema } from '../../utils/trips';

export const useTripAnomalyData = tripAnomalyData => {
  const { tripData, calculations, note } = tripAnomalyData || {};
  const { distanceAndCoordinatesAdjustment, overlappingTripsIds } = calculations || {};

  const trips = useMemo(() => {
    if (!overlappingTripsIds?.length) return [];
    return overlappingTripsIds.map(trip => normalizeTripsSchema(trip));
  }, [overlappingTripsIds]);

  const journeyTimestamps = useMemo(() => {
    if (!tripData) {
      return { startTs: null, endTs: null };
    }

    return {
      startTs: distanceAndCoordinatesAdjustment?.journeyStartTs ?? tripData.journeyStartTs,
      endTs: distanceAndCoordinatesAdjustment?.journeyEndTs ?? tripData.journeyEndTs,
    };
  }, [distanceAndCoordinatesAdjustment, tripData]);

  const hasTripData = Boolean(tripData && Object.keys(tripData).length > 0);
  const hasAdjustmentData = Boolean(
    distanceAndCoordinatesAdjustment &&
      distanceAndCoordinatesAdjustment.journeyGeoJson &&
      distanceAndCoordinatesAdjustment.distance != null,
  );
  const hasOverlappingTrips = trips.length > 0;
  const hasNote = Boolean((typeof note === 'string' ? note.trim().length : 0) > 0);

  return {
    trips,
    tripData,
    distanceAndCoordinatesAdjustment,
    note,
    hasTripData,
    hasAdjustmentData,
    hasOverlappingTrips,
    hasNote,
    journeyTimestamps,
  };
};
